import React, { useEffect } from "react";
// import SearchIcon from "../../../assets/icons/search.svg";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../../customHooks/useDebounceHook";

type Props = {
  search?: boolean;
};

const SearchBox = (props: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialQuery = searchParams.get("groupSearch") || "";
  const [input, setInput] = React.useState(initialQuery);
  const debounceValue = useDebounce(input);

  useEffect(() => {
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("groupSearch", debounceValue);
    setSearchParams(updatedParams);
  }, [debounceValue, searchParams, setSearchParams]);

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput(event.target.value);
  };
  return (
    <>
      <div className={tw`rounded relative`}>
        <input
          type="text"
          className={tw`border p-2 rounded w-full text-gray-700 focus: outline-none  border-gray-300 focus:border-primary transition duration-500`}
          placeholder="Search"
          value={input}
          onChange={(e) => onChangeInput(e)}
        />
      </div>
    </>
  );
};

export default SearchBox;
